// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"412":"32656264","772":"8d7587b9","879":"f7851240"}[chunkId] + ".js";
};